declare global {
    interface Window {
        gtag: (
            command: 'event',
            eventName: string,
            parameters: Record<string, any>,
        ) => void;
    }
}

export const trackEvent = (
    eventName: string,
    parameters: Record<string, any>,
) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, parameters);
    }
};

export const isGALoaded = () => {
    return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

export const trackHyperReportCompleted = (
    userId: string,
    hyperScore: number,
    planTier: 'free' | 'pro' | 'team',
) => {
    trackEvent('hyper_report_completed', {
        user_id: userId,
        hyper_score: hyperScore,
        plan_tier: planTier,
        timestamp: new Date().toISOString(),
    });
};

export const trackAccountCreated = (
    userId: string,
    signupSource:
        | 'organic'
        | 'google_ads'
        | 'referral'
        | 'paid_social'
        | 'paid_search',
) => {
    trackEvent('account_created', {
        user_id: userId,
        signup_source: signupSource,
        timestamp: new Date().toISOString(),
    });
};
